import { render, staticRenderFns } from "./HistoryNotification.vue?vue&type=template&id=0731d6de"
import script from "./HistoryNotification.vue?vue&type=script&lang=js"
export * from "./HistoryNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports